import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonApp } from '@ionic/angular/standalone';

/**
 * Blume Admin - the internal Blume admin console. The root is deliberately
 * bare: ion-app plus a plain router-outlet. /sign-in and /not-authorised
 * render on their own; everything else lives inside the guarded Shell
 * (ion-tabs + a floating top toolbar and bottom tab bar).
 */
@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonApp, RouterOutlet],
  template: `
    <ion-app>
      <router-outlet />
    </ion-app>
  `,
})
export class App {}
